import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Transfer } from '../domain/data';
import { TransferInterface } from '../../core';
import { Serializer } from '../client/helpers/serializer/serializer';

@Injectable({
    providedIn: 'root',
})
export class TransferResolver implements Resolve<TransferInterface> {
    constructor(private router: Router, private serializer: Serializer) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TransferInterface> {
        if (!this.router.getCurrentNavigation()?.extras.state.transfer) {
            throw new Error('Transfer not found');
        }

        return this.serializer.fromJson(this.router.getCurrentNavigation()?.extras.state.transfer, Transfer);
    }
}
